import { getApi, postApi } from '../../../comm/middleware/callApi';
import apis from '../../../comm/api/apis';

/**
 * 绑定用户和专家
 * @param commit
 * @param dyml dayima 带过来的登录参数
 */
export const bindExpert = ({ commit }, { dyml, expertid }) => {
  return getApi({ commit }, apis.bindExpert, { dyml, expertid })
  .then((body) => {
    return body.data;
  });
};

/**
 * 查询绑定状态
 * @param commit
 * @param dyml dayima 带过来的登录参数
 */
export const checkExpert = ({ commit }, { dyml, expertid }) => {
  return getApi({ commit }, apis.checkExpert, { dyml, expertid })
  .then((body) => {
    return body.data;
  });
};
// 实名认证（含境外人员）
export const bindAuthentication = ({ commit }, params) => {
  return getApi({ commit }, apis.authentication, params)
    .then((body) => {
      return body.data;
    });
};


/**
 * 查询省份列表
 * @param commit
 */
export const getProvinceList = ({ commit }) => {
  return getApi({ commit }, apis.proList, {}, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, false)
  .then((body) => {
    return body;
  });
};

/**
 * 查询城市区县列表
 * @param commit
 * @param id 上级id
 */
export const getAreaList = ({ commit }, { id }) => {
  return getApi({ commit }, apis.areaList, { id }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, false)
  .then((body) => {
    return body;
  });
};

/**
 * 美囤上传图片
 */
export const bindMtUploadPic = ({ commit }, { formData, token, isHttps, isPrivateImage }) => {
  formData.append('token', token);
  formData.append('isPrivateImage', 1);
  formData.append('isHttps', isHttps);
  formData.append('isPrivateImage', isPrivateImage);
  return postApi({ commit }, apis.mtUploadPic, formData, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } })
    .then((data) => {
      return data.data;
    });
};

/**
 * 获取国籍
 */
export const getCountryInfo = ({ commit }) => {
  return getApi({ commit }, apis.getCountryInfo)
    .then((body) => {
      return body;
    });
};



// WEBPACK FOOTER //
// ./src/store/user/dayima/actions.dayima.js